export const PEPTIDE_OPTIONS = [
  'AOD',
  'ARA 290',
  'BPC-157',
  'BPC-157/TB-500',
  'CJC-1295 No DAC',
  'CJC-1295 w/DAC',
  'DSIP',
  'Epitalon',
  'GHK-Cu',
  'GHRP-2',
  'GHRP-6',
  'GLP1/GIP/GCGR',
  'Glutathione',
  'HCG',
  'Hexarelin',
  'HGH Frag 176-191',
  'HGH',
  'Humanin',
  'IGF-1 LR3',
  'Ipamorelin',
  'Ipamorelin/CJC-1295 No DAC',
  'Kisspeptin',
  'KPV',
  'LL-37',
  'Melanotan II',
  'MGF',
  'MOTs-C',
  'NAD+',
  'P21',
  'PE-22-28',
  'Pinealon',
  'PT-141',
  'Selank',
  'Semax',
  'Sermorelin',
  'SS-31',
  'TA-1',
  'TB-500',
  'Tesamorelin',
  'Thymalin',
  'Other'
] as const;

export type PeptideName = typeof PEPTIDE_OPTIONS[number];